module.exports = __webpack_public_path__ + "static/img/37.e4203406.jpeg";